
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  connect() {
   console.log("------ bildinhalte controller connect -------------")
  }

  change(event) {
    const reiseId = this.selectTarget.value;
    console.log("--------------------------- reise_id ist ", reiseId)
    const url = `/reisen/${reiseId}/inhalte/bildinhalte`;
    fetch(url, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}

